<template>
    <v-card class="my-1" :loading="loading">
        <v-card-text>
            <div class="text-h5">
                {{item.codperlet}} - {{item.titulo}}
            </div>
            <v-divider class="my-2"></v-divider>
            <v-row>
                <v-col cols="12" sm="12">
                    <!-- ADD ITEM -->
                    <div>
                        <div class="mb-1">
                            <label>Adicionar item à lista:</label>
                        </div>
                        <v-row>
                            <v-col cols="12" sm="8" md="5">
                                <v-autocomplete
                                    hide-details
                                    label="Selecione Material"
                                    v-model="novoItem.material"
                                    :items="computedMateriais"
                                    item-value="id"
                                    item-title="descricao"
                                    no-data-text="Nenhum Material"
                                    ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="4" md="4" lg="2">
                                <v-text-field hide-details
                                    placeholder="Qtde"
                                    v-model="novoItem.qtde_exigida"
                                    step="1"
                                    type="number">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="3">
                                <v-btn color="success"
                                    elevation="0"
                                    :disabled="!novoItem.qtde_exigida || !novoItem.material"
                                    @click="onAddItem"
                                    >Adicionar</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
                <v-divider class="my-2"></v-divider>
                <v-col cols="12" sm="12" md="8">
                    <div style="overflow-y:auto; height:330px; width:100%" class="pa-2 mb-2">
                        <v-table>
                            <thead>
                                <tr>
                                    <th class="text-left"> Material </th>
                                    <th width="150" class="text-left"> Qtde </th>
                                    <th width="150" class="text-right"> Ações </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in lista_materiais" :key="item.id">
                                    <td>{{ item.material_object.descricao }}</td>
                                    <td>
                                        <v-text-field style="max-width: 250px"
                                            v-model="item.qtde_exigida" type="number" hide-details>
                                        </v-text-field>
                                    </td>
                                    <td class="text-right">
                                        <v-btn icon color="error" title="Remover Material"
                                            @click="removeItem(item)"
                                            :loading="$store.state.checklistdb.loading_id == `delete-lista-materiais-${item.id}`">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                        <v-btn icon color="success" title="Salvar alteração do Material"
                                            @click="updateItem(item)"
                                            :loading="$store.state.checklistdb.loading_id == `update-lista-materiais-${item.id}`">
                                            <v-icon>mdi-content-save</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </v-table>
                        <div v-if="false">
                            <div v-for="lm in lista_materiais" :key="lm.id">
                                <div>
                                    <label class="mt-1"><b>{{lm.material_object.descricao}} </b>&nbsp;
                                        <span class="text-disabled text-caption mr-2">Qtde Exigida</span>
                                    </label>
                                    <v-text-field style="max-width: 250px"
                                        v-model="lm.qtde_exigida" type="number" hide-details>
                                        <template v-slot:append>
                                            <v-btn icon color="error" title="Remover Material"
                                                @click="removeItem(lm)"
                                                :loading="$store.state.checklistdb.loading_id == `delete-lista-materiais-${lm.id}`">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                            <v-btn icon color="success" title="Salvar alteração do Material"
                                                @click="updateItem(lm)"
                                                :loading="$store.state.checklistdb.loading_id == `update-lista-materiais-${lm.id}`">
                                                <v-icon>mdi-content-save</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-text-field>
                                    <v-divider></v-divider>
                                </div>
                                <pre v-show="false">{{lm}}</pre>
                            </div>
                        </div>
                    </div>
                    <helper-gdb text="ItemListaSelecionada" v-if="$store.getters.StateAuthenticatedUser.is_superuser && false"/>
                </v-col>
            </v-row>
            <helper-gdb text="ItemListaSelecionada"/>
        </v-card-text>
    </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    components: {
    },
    props: {
        item: {
            required: true
        },
        loading: {
            default: false
        }
    },
    data: () => ({
        lista_materiais: [],
        novoItem: {}
    }),
    methods: {
        ...mapActions([
            'GetCheckListListaMateriais',
            'GetCheckListMateriais',
            'CreateCheckListListaMaterial',
            'DeleteCheckListListaMaterial',
            'UpdateCheckListListaMaterial'
        ]),
        init(){
            setTimeout(
                () => {
                    this.get_lista_materiais()
                }, 500
            )
        },
        async get_lista_materiais(){
            this.lista_materiais = []
            this.lista_materiais = await this.GetCheckListListaMateriais({ lista_id: this.item.id })
            this.GetCheckListMateriais({codperlet: this.item.codperlet})
        },
        // async get_materiais(){
        //     if(this.StateCheckListMateriais.length == 0){
        //         this.GetCheckListMateriais()
        //     }
        // },
        async onAddItem(){
            if(!this.novoItem.material || !this.novoItem.qtde_exigida){
                return alert('Preencha todos os campos!')
            }
            if(this.novoItem.qtde_exigida == 0){
                return alert('Quantidade exigida deve ser maior que zero!')
            }
            const payload = Object.assign({}, this.novoItem)
            this.novoItem = Object.assign({},{})
            payload['lista'] = this.item.id
            const created = await this.CreateCheckListListaMaterial(payload)
            if(created){
                this.$emit('on-created', created)
                this.init()
            }
        },
        async removeItem(item){
            const confirma = confirm('Tem certeza que deseja remover o item: '+item.material_object.descricao)
            if(!confirma) return
            if(!item.id){
                return alert('Item não identificado!')
            }
            const deleted = await this.DeleteCheckListListaMaterial(item)
            if(deleted){
                this.$emit('on-deleted', deleted)
                this.init()
            }
        },
        async updateItem(payload){
            if(!payload.id){
                return alert('Item não identificado!')
            }
            const updated = await this.UpdateCheckListListaMaterial(payload)
            if(updated){
                this.$emit('on-updated', updated)
                this.init()
            }
            //TODO
        }
    },
    mounted(){
        this.init()
    },
    computed: {
        ...mapGetters(['StateCheckListMateriais']),
        computedMateriais(){
            const material_key = this.lista_materiais.map(li=>li.material)
            const materiais = this.StateCheckListMateriais
                .filter(o => !(material_key.includes(o.id)))
            // console.log(stateMateriais.filter(o => !lista_materiais.map(tt=>tt.material).includes(o.material)))
            return materiais
        }
    },
    watch: {
        item: {
            handler(){
                this.get_lista_materiais()
            }
        }
    }
}
</script>
<style>
.v-input__append-outer{
    margin-top: 0px !important;
}
</style>
